import { faBowlChopsticks, faPlus } from '@fortawesome/pro-regular-svg-icons';
import { useDisclosure } from '@mantine/hooks';
import type { JSX } from 'react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, EmptyState, Icon } from '@feathr/components';
import Page from '@feathr/extender/App/Page';
import { GeoFilterModal } from '@feathr/extender/components';
import GeoFilterDefaultModal from '@feathr/extender/components/Targetings/GeoFilterDefaultModal';

import * as styles from './GeoFiltersPage.css';

function GeoFiltersPage(): JSX.Element {
  const { t } = useTranslation();

  const [editCreateModalContext, setEditCreateModalContext] = useState<'create' | 'edit'>('create');

  const [isEditCreateModalOpen, { open: openEditCreateModal, close: closeEditCreateModal }] =
    useDisclosure(false);
  const [isDefaultModalOpen, { open: openDefaultModal, close: closeDefaultModal }] =
    useDisclosure(false);

  function handleOpenCreateEditModal(context: 'create' | 'edit'): () => void {
    return () => {
      setEditCreateModalContext(context);
      openEditCreateModal();
    };
  }

  return (
    <Page
      actions={[
        // TODO: Remove "Set default" button. This is here for you, the smoke tester, until I have the tables up.
        <Button
          key={'assign-default'}
          onClick={openDefaultModal}
          prefix={<Icon icon={faBowlChopsticks} />}
        >
          {t('Assign as default')}
        </Button>,
        // TODO: Remove "Edit set" button. This is here for you, the smoke tester, until I have the tables up.
        <Button
          key={'edit-set'}
          onClick={handleOpenCreateEditModal('edit')}
          prefix={<Icon icon={faPlus} />}
        >
          {t('Edit set')}
        </Button>,

        <Button
          key={'create-set'}
          onClick={handleOpenCreateEditModal('create')}
          prefix={<Icon icon={faPlus} />}
        >
          {t('Create set')}
        </Button>,
      ]}
      collapseHeader={false}
      collapseHeaderOnScroll={true}
      contentClassName={styles.pageContent}
      description={t(
        'Create and manage geofilter sets that allow you to target your campaigns by location. These sets can be used across ad campaigns.',
      )}
      showHeader={true}
      title={'Geofilters'}
    >
      <EmptyState
        description={t('Get started by creating a new set.')}
        height={'full'}
        label={t('No geofilters')}
        theme={'white'}
        width={'full'}
      >
        <Button onClick={handleOpenCreateEditModal('create')} prefix={<Icon icon={faPlus} />}>
          {t('Create set')}
        </Button>
      </EmptyState>
      <GeoFilterModal
        context={editCreateModalContext}
        onClose={closeEditCreateModal}
        opened={isEditCreateModalOpen}
      />
      <GeoFilterDefaultModal
        // TODO: Pass the correct geoFilterName
        geoFilterName={t('Tokyo Metropolis')}
        onClose={closeDefaultModal}
        opened={isDefaultModalOpen}
      />
    </Page>
  );
}

export default GeoFiltersPage;
